
  import { Vue, Component, Prop, Emit } from "vue-property-decorator";
  import {
    ISearchBarViewModel,
    IParentMenuModel,
    IStateModel,
    DateRangeModel,
    DropdownViewModel
  } from "@/models";
  import { OptionService } from "@/services/OptionService";
  import { ChildMenuModel } from "@/models/ChildMenuModel";

  @Component({
    name: "TheSearchbar"
  })
  export default class TheSearchBar extends Vue {
    @Prop()
    form!: ISearchBarViewModel;
    category?: IParentMenuModel[];
    state?: IStateModel[];
    date?: DateRangeModel[];

    constructor() {
      super();
      this.category = [
        { id: 0, name: "", children: [] as ChildMenuModel[] }
      ] as IParentMenuModel[];
      this.state = [{ stateId: 0, stateLong: "" }] as IStateModel[];
      this.date = [{ hours: 0, label: "" }] as DateRangeModel[];
    }

    async created() {
      const response = await OptionService.GetSearchbarOption();
      if (response.status === 200) {
        this.state = response.data.states;
        this.date = response.data.dateRanges;
        this.category = response.data.categories;
      }
    }

    @Emit("onSearchChange")
    onSearchChange(form: ISearchBarViewModel) {}

    onSearch() {
      this.onSearchChange(this.form);
      const { category, state, date, searchText } = this.form;
      this.$router
        .push({
          name: "PageSearch",
          params: {
            categoryId: category.toString(),
            stateId: state.toString(),
            date: date.toString(),
            searchText: searchText === "" ? " " : searchText
          }
        })
        .catch(err => {});
    }
  }
